export const LOCAL_STORAGE_NEWSLETTER_DIALOG: string = 'newsletterDialog'
export const LOCAL_STORAGE_LOCALE_DIALOG: string = 'localeDialog'
export const LOCAL_STORAGE_OUT_OF_STOCK_SIGNUP_DIALOG: string = 'outOfStockSignupDialog'
export const LOCAL_STORAGE_RECENTLY_VIEWED: string = 'recentlyViewed'
export const LOCAL_STORAGE_EMAIL_UNVERIFIED: string = 'emailUnverified'
export const LOCAL_STORAGE_LIST: string = 'list'
export const LOCAL_STORAGE_WISHLIST: string = 'wishlist'
export const LOCAL_STORAGE_ALGOLIA_QUERY_INFO: string = 'algoliaQueryInfo'

export const setInStorage = <T>(key: string, value: T, useSessionStorage = false, stringify = false): void => {
  try {
    const storage = getStorage(useSessionStorage)

    if (!storage) {
      return
    }

    const serializedValue = stringify ? JSON.stringify(value) : (value as unknown as string)

    storage.setItem(key, serializedValue)
  } catch (error) {
    console.error(`Error setting storage key "${key}":`, error)
  }
}

export const getFromStorage = <T>(key: string, useSessionStorage = false, parse = false): T | null => {
  try {
    const storage = getStorage(useSessionStorage)

    if (!storage) {
      return null
    }

    const value = storage.getItem(key)

    if (value === null) {
      return null
    }

    return parse ? (JSON.parse(value) as T) : (value as unknown as T)
  } catch (error) {
    console.error(`Error getting storage key "${key}":`, error)

    return null
  }
}

export const removeFromStorage = (key: string, useSessionStorage = false): void => {
  try {
    const storage = getStorage(useSessionStorage)

    if (!storage) {
      return
    }

    storage.removeItem(key)
  } catch (error) {
    console.error(`Error removing storage key "${key}":`, error)
  }
}

export const hasInStorage = (key: string, useSessionStorage = false): boolean => {
  try {
    const storage = getStorage(useSessionStorage)

    if (!storage) {
      return false
    }

    return storage.getItem(key) !== null
  } catch (error) {
    console.error(`Error checking storage key "${key}":`, error)

    return false
  }
}

const getStorage = (useSessionStorage: boolean): Storage | null => {
  if (typeof window === 'undefined') {
    return null
  }

  return useSessionStorage ? window.sessionStorage : window.localStorage
}
